<rp-config *authorize-read-write></rp-config>
